import {PluginListenerHandle, registerPlugin} from "@capacitor/core";
import {ActionPerformed} from "@capacitor/push-notifications";

interface AdobePushNotificationsPluginTypes {
    addListener(eventName: 'pushNotificationActionPerformed', listenerFunc: (notification: ActionPerformed) => void): Promise<PluginListenerHandle> & PluginListenerHandle;
}

// Capacitor plugin for communicating with the Adobe SDK.
export const AdobePushNotificationsPlugin = registerPlugin<AdobePushNotificationsPluginTypes>('AdobePushNotificationsPlugin');
